import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';

@Component({
    selector: 'msc-showroom-exhibit-checkbox-page',
    templateUrl: './showroom-exhibit-checkbox-page.component.html',
    styleUrls: ['./showroom-exhibit-checkbox-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class ShowroomExhibitCheckboxPageComponent {
    public form: FormGroup;

    constructor(
        private readonly fb: FormBuilder,
    ) { }

    ngOnInit(): void {
        this.form = this.getFormGroup();
    }

    /**
     * Get the form group
     */
    getFormGroup(): FormGroup {
        return this.fb.group({
            'coffee': new FormControl(true),
            'soda': new FormControl(true),
            'water': new FormControl(true),
        });
    }
}
